import React, { Component, useState, useEffect } from "react";
import * as Yup from "yup";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { forgotPassApi, otpVerificaionApi } from "../Service/ApiService";
import { useNavigate, useLocation } from "react-router-dom";

// Define validation schema
const schema = Yup.object().shape({
  otp: Yup.string()
    .required("OTP is required")
    .matches(/^\d+$/, "OTP must contain only numbers")
    .length(6, "OTP must be exactly 6 characters"),
});

const OTPVerificationController = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const { mobile, vendorCode, your_otp } = location.state || {};
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(60); // 1 minute
  const [canResend, setCanResend] = useState(false);
  const [OTP, setOTP] = useState("");

  // Validate individual field on change
  const validateField = async (fieldName, value) => {
    try {
      await Yup.reach(schema, fieldName).validate(value);
      setErrors((prev) => ({ ...prev, [fieldName]: null }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
    }
  };

  useEffect(() => {
    setOTP(your_otp);
  }, []);

  const handleOTPChange = (e) => {
    let inputValue = e.target.value;

    validateField("otp", inputValue);

    setFormData({ ...formData, [e.target.name]: inputValue });
  };

  const handleSubmit = async () => {
    try {
      await schema.validate({ otp: formData.otp }, { abortEarly: false });
      showAlert(response.msg, {
        icon: "success",
        title: "Success",
      });
      navigate("/reset-password", { state: { vendorCode } });
    } catch (err) {
      setErrors({ otp: err.errors[0] });
    }
  };

  const handleOTPverify = async () => {
    try {
      setLoading(true);
      const response = await otpVerificaionApi(mobile, vendorCode, formData.otp);
      if (response.success) {
        showAlert(response.msg, {
          icon: "success",
          title: "Success",
        });
        navigate("/reset-password", { state: { vendorCode } });
      } else {
        showAlert(response.msg);
      }
    } catch (error) {
      showAlert(error);
      // showAlert("Please fill valid inputs!");
    } finally {
      setLoading(false);
    }
  };

  const resendOTP = async () => {
    try {
      setLoading(true);
      const response = await forgotPassApi(vendorCode, mobile);
      if (response.success) {
        setOTP(response.data.otp);
        // showSuccessAlert(response.msg, "Message");
        setResendTimer(60); // reset timer
        setCanResend(false);
      } else {
        setApiError(response.msg);
      }
    } catch (error) {
      setApiError("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Only start timer if resend is not allowed
    if (canResend) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResend(true); // enable resend after timer ends
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [canResend]);

  // Format timer to mm:ss
  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  return {
    vendorCode,
    mobile,
    OTP,
    errors,
    handleOTPChange,
    handleSubmit,
    handleOTPverify,
    resendOTP,
    canResend,
    resendTimer,
    formatTimer,
  };
};

export default OTPVerificationController;
